module.exports = __webpack_public_path__ + "static/img/icon_show_not_fly.1bb08f7f.svg";